// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2Bf-s","head":"Table_head__3SSQx","col":"Table_col__1RR7j"};